import React, { useContext, useEffect, useState } from "react";
import { UserContext } from "../../context/UserContextProvider";
import { ClientConfigurationContext } from "../../context/ClientConfigurationContextProvider";
import { useNavigate } from "react-router-dom";
import ReportPage from "./ReportPage";
import { AgentAccessContext } from "../../context/AgentAccessContextProvider";
import Layout from "../Layout";
import { getSalesLeaderAgentProfile } from "../../api/internal-identity";
import Loader, { Types } from "../gdk/Loader";

function salesLeaderProfileToSubstituteInfo(profile) {
    if (!profile) {
        return null;
    }
    const id = profile.agentId ?? null;
    const name = profile.agentName ?? null;
    const role = profile.agentProfile ?? null;
    const agencyId = profile.agencyId ?? null;
    return { id, name, role, agencyId };
}

function substituteInfoFromLocalStorage() {
    return {
        id: localStorage.getItem("substituteAgentId") || null,
        name: localStorage.getItem("substituteAgentName") || null,
        role: localStorage.getItem("substituteAgentProfile") || null,
        agencyId: localStorage.getItem("substituteAgencyId") || null
    };
}

export default function SalesLeaderReportPage() {
    const user = useContext(UserContext);
    const clientConfiguration = useContext(ClientConfigurationContext);
    const agentAccess = useContext(AgentAccessContext);
    const navigate = useNavigate();
    const [overrideUserAccess, setOverrideUserAccess] = useState(false);
    const [substituteAgentInfo, setSubstituteAgentInfo] = useState(null);
    const [substituteInfoReady, setSubstituteInfoReady] = useState(false);

    useEffect(() => {
        if (!clientConfiguration) {
            return;
        }

        if (!clientConfiguration.enableSalesLeaderSessionFeature) {
            setSubstituteAgentInfo(substituteInfoFromLocalStorage());
            setSubstituteInfoReady(true);
            return;
        }

        let cancelled = false;
        getSalesLeaderAgentProfile()
            .then((profile) => {
                if (!cancelled) {
                    setSubstituteAgentInfo(salesLeaderProfileToSubstituteInfo(profile));
                }
            })
            .catch(() => {
                if (!cancelled) {
                    setSubstituteAgentInfo(null);
                }
            })
            .finally(() => {
                if (!cancelled) {
                    setSubstituteInfoReady(true);
                }
            });
        return () => {
            cancelled = true;
        };
    }, [clientConfiguration]);

    useEffect(() => {
        if (!substituteInfoReady) {
            return;
        }
        if (!user.authorizations?.canAccessReports || !substituteAgentInfo?.id) {
            navigate("/dashboard");
        }
    }, [substituteInfoReady, user, substituteAgentInfo, navigate]);

    if (!clientConfiguration || !substituteInfoReady) {
        return <Loader type={Types.Section} />;
    }

    if (!user.authorizations?.canAccessReports || !substituteAgentInfo?.id) {
        return null;
    }

    const agentCannotAccessReports = (
        <Layout>
            <div className="container">
                <br />
                <h4>{substituteAgentInfo.role === "IA Principal"
                    ? `Agent ${substituteAgentInfo.id} does not have access to reports.`
                    : `Agent ${substituteAgentInfo.id} is not a principal so they do not have access to reports.`
                }</h4>
                <br />
                <div>
                    <gds-button href="/dashboard"> Return to agent search </gds-button>
                    {substituteAgentInfo.role === "IA Principal" && <> <gds-button onClick={() => setOverrideUserAccess(true)}> Continue to report </gds-button></>}
                </div>
            </div>
        </Layout>
    );

    return (agentAccess && (
        agentAccess?.externalReportsEnabled || overrideUserAccess
            ? <ReportPage substituteAgentInfo={substituteAgentInfo} />
            : agentCannotAccessReports
    ));
}